"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.1.13.0", "build_date": "2022-03-02T18:04:11.018Z", "build_branch": "development", "build_commit": "da1a4bf2b2ea6cff6f27e772106191cda67c6cd1" };
//# sourceMappingURL=build_data.js.map